import { render, staticRenderFns } from "./chat2.vue?vue&type=template&id=1333e3ed&scoped=true"
import script from "./chat2.vue?vue&type=script&lang=js"
export * from "./chat2.vue?vue&type=script&lang=js"
import style0 from "./chat2.vue?vue&type=style&index=0&id=1333e3ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333e3ed",
  null
  
)

export default component.exports